import { createApp } from "vue";
import App from "./App.vue";

import "vuetify/styles";
import { createVuetify } from "vuetify";
import * as components from "vuetify/components";
import * as directives from "vuetify/directives";
import { aliases, mdi } from "vuetify/iconsets/mdi";
import "@mdi/font/css/materialdesignicons.css";

import router from "../router";
import store from "../store";

import Keycloak from "keycloak-js";


const vuetify = createVuetify({
  components,
  directives,
  icons: {
    defaultSet: "mdi",
    aliases,
    sets: {
      mdi,
    },
  },
});

let initOptions = {
  url: process.env.VUE_APP_KEYCLOAK_URL || "https://idm.dataplatform-yamanashi.jp/auth",
  realm: process.env.VUE_APP_KEYCLOAK_REALM || "Smartcity",
  clientId: process.env.VUE_APP_KEYCLOAK_CLIENT_ID || "admin-system",
};

let keycloak = new Keycloak(initOptions);

keycloak
  .init({
    onLoad: "login-required",
    checkLoginIframe: false,
  })
  .then(async (auth) => {
    if (!auth) {
      console.error("Keycloak authentication failed");
      return;
    } else {
      let app = createApp(App);
      app.provide(process.env.VUE_APP_KEYCLOAK_PROVIDE_VARIABLE, keycloak);
      app = createApp(App, { keycloak: keycloak });
      app.use(router);
      app.use(store);
      app.use(vuetify);
      app.mount("#app");
    }

    //Token Refresh
    setInterval(() => {
      keycloak
        .updateToken(70)
        .then((refreshed) => {
          if (refreshed) {
            console.log("Token refreshed" + refreshed);
          } else {
            console.log(
              "Token not refreshed, valid for " +
                Math.round(
                  keycloak.tokenParsed.exp +
                    keycloak.timeSkew -
                    new Date().getTime() / 1000
                ) +
                " seconds"
            );
          }
        })
        .catch(() => {
          console.log("Failed to refresh token");
        });
    }, 6000);
  })
  .catch((e) => {
    console.log("Serwer lezy: " + e);
  });
